<template>
	<section class="cargos">
		<div
			class="cargos-container"
			v-if="allDriverRequestsComputed?.collection?.length && !loading.allDriverRequests"
		>
			<PagesCargosCard
				v-for="request in allDriverRequestsComputed.collection"
				:key="request.id"
				:request="request"
				class="cargo-item"
				@addedComment="addedCommentHandler"
			/>
		</div>
		<div
			v-else-if="allDriverRequestsComputed?.collection?.length === 0 && !loading.allDriverRequests"
			class="empty-container"
		>
			<TypographyKTypographyBody3
				color="var(--white)"
				font-type="medium"
			>
				{{ 'Грузов нет' }}
			</TypographyKTypographyBody3>
		</div>
		<UiLoaderLottie
			class="loader"
			v-else-if="loading.allDriverRequests"
			:circle-width="2"
			:color="'var(--loader-primary)'"
			:radius="20"
		/>
	</section>
</template>

<script setup lang="ts">
	import { useCargoCommentStore } from '~/store/cargoComment.store';
	import { useDriverRequestStore } from '~/store/driverRequests.store';
	import type { ICargoCommentAddResponse, ICargoCommentItem } from '~~/shared/interfaces/cargoComment';

	const driverRequestStore = useDriverRequestStore();
	const cargoCommentStore = useCargoCommentStore();
	const pageReqInterval = ref<NodeJS.Timeout | null>(null);
	const { loading, getDriverRequests } = driverRequestStore;

	const allDriverRequestsComputed = computed(() => driverRequestStore.allDriverRequests);

	const addedCommentHandler = async (
		data: ICargoCommentAddResponse,
		additionalData: { callbackFunction: () => void }
	) => {
		const response = await cargoCommentStore.addCargoComment(data);

		if (response?.status === 'success') {
			additionalData?.callbackFunction();
		}
	};

	getDriverRequests(true);

	onMounted(() => {
		pageReqInterval.value = setInterval(() => {
			getDriverRequests(false);
		}, 20000);
	});

	onUnmounted(() => {
		if (pageReqInterval.value) {
			clearInterval(pageReqInterval.value);
			pageReqInterval.value = null;
		}
	});
</script>

<style scoped lang="scss">
	.cargos {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;

		.cargos-container {
			display: flex;
			flex-direction: column;
			margin-top: 20px;

			.cargo-item {
				margin-bottom: 14px;

				&:last-child {
					margin-bottom: 0px;
				}
			}
		}

		.loader {
			margin: auto;
		}

		.empty-container {
			margin: auto;
		}
	}
</style>
